import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "color-style"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#color-style" }),
  /*#__PURE__*/_createTextVNode(" Color Style ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".btn-color-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set a button's text and icon colors only: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<a href="#" class="btn btn-bg-light btn-color-primary">primary</a>
        <a href="#" class="btn btn-bg-light btn-color-success">success</a>
        <a href="#" class="btn btn-bg-light btn-color-info">info</a>
        <a href="#" class="btn btn-bg-light btn-color-warning">warning</a>
        <a href="#" class="btn btn-bg-light btn-color-danger">danger</a>
        <a href="#" class="btn btn-bg-light btn-color-dark">dark</a
        >`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: [`btn-color-${item}`, "btn btn-bg-light me-2 mb-2"]
          }, _toDisplayString(item), 3))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}